import styled from 'styled-components';

import { FormLabel } from 'ui/formField';
import { InfoBanner } from 'ui/banner';
import { RadioList } from 'ui/radioList';
import { Row, TopText } from 'ui/radioList/RadioListStyles';
import { spacing } from 'ui/theme';

export const StyledFormLabel = styled(FormLabel)`
  margin-bottom: ${spacing.half};
`;

export const StyledRadioList = styled(RadioList)`
  ${Row} {
    margin-bottom: 0;
  }

  ${TopText} {
    margin-top: 3px;
  } ;
`;

export const StyledBanner = styled(InfoBanner)`
  margin-top: ${spacing.base};

  a {
    color: inherit;
    text-decoration: underline;
  }
`;
